var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"c-audio-view"}},[_c('audio',{attrs:{"src":_vm.audioUrl,"controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }